// extracted by mini-css-extract-plugin
export default {"eyeIcon":"reNewPassword_eyeIcon__eBcZX"};